export { default } from './RoleRequiredRoute';



// WEBPACK FOOTER //
// ./src/routing/RoleRequiredRoute/index.ts